<template>
<div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="configEditLabel">Custom Script Results</h5>

          <button type="button" class="btn-close" @click="$emit('closeModal')"></button>
        </div>
        <div class="modal-body">
          <form id="processscripts" method="post">
            <div v-for="(value, name, index) in scriptresults">
              <a :href="generateLink(name,value)" target="_blank" class="btn btn-lg btn-default">{{name}} <span class="status_con d-none">(<b>Status:</b> <em :class="scriptstatus[index]">{{scriptstatus[index]}}</em>)</span> <i class="fas fa-download"></i></a>
              
            </div>
            <div class="form-group">
              <button type="button" class="btn btn-light" @click="$emit('closeModal')">Cancel</button>
              <button type="button" class="btn btn-primary d-none" @click="onSubmit">Submit</button>
            </div>
          </form>
        </div>
      </div>
</template>
<script>
import axios from 'axios';
export default {
  name: 'ModalDeleteDataset',
    props: {
      passedModalData: '',
      userData: []
    },
    data() {
      return {
        scriptresults: [],
        scriptstatus: []
      }
    },
    methods: {
      generateLink(n,m) {
        var finlink = '/script_download?scriptname='+n+'&scriptresult='+m;
        return finlink;
      },
      checkScriptStatus(r) {
        let formData = new FormData();
        formData.append('run_id', r);
          axios.post('/script_complete', formData)
          .then(
            (response) => {
              console.log('script response '+JSON.stringify(response.data));
              return JSON.stringify(response.data);
            }
          )
          .catch(
            (error) => {
              this.errorMessage = error.message;
              console.error("There was an error!", error);
              }
          )
      },
      iterateScriptStatus() {
        console.log('script results length '+this.scriptresults.length);
            for (var i = 0; i < this.scriptresults.length; i++) {
              var curstat = this.checkScriptStatus(this.scriptresults[i]);
              this.scriptstatus.push(curstat); 
              console.log('iterate script '+this.scriptresults[i]+' and status is '+curstat);
            };
            console.log('script status whole '+JSON.stringify(this.scriptstatus));
      }
    },
     mounted() {
      axios({
        method : 'POST',
        url : '/script_results'
      }).then(
            (response) => {
              this.scriptresults = response.data;
			        console.log('SCRIPT RESULTS response: '+JSON.stringify(this.scriptresults));
              // setInterval(this.iterateScriptStatus(this.scriptresults), 300);
              this.iterateScriptStatus(this.scriptresults)
        })
        .catch(error => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
      });
      
    }
}
</script>